import React from "react";
import PropTypes from "prop-types";
import {
  ReactRequiredChildren,
  ReactDefaultProps,
  ReactComponentStaticProps,
} from "../../types/react";

import styles from "./ComparisonTable.scss";

type ComparisonTableHeadlineBaseProps<Tag extends React.ElementType> = {
  tag?: Tag;
};

export const ComparisonTableHeadlineDefaultTagName = "h2";
export type ComparisonTableHeadlineDefaultTag = typeof ComparisonTableHeadlineDefaultTagName;

export type ComparisonTableHeadlineProps<
  Tag extends React.ElementType = ComparisonTableHeadlineDefaultTag
> = ComparisonTableHeadlineBaseProps<Tag> &
  Omit<
    ReactRequiredChildren<React.ComponentPropsWithoutRef<Tag>>,
    keyof ComparisonTableHeadlineBaseProps<Tag>
  >;

const defaultProps = {
  tag: ComparisonTableHeadlineDefaultTagName,
} as const;

const validatedDefaultProps: ReactDefaultProps<
  ComparisonTableHeadlineBaseProps<ComparisonTableHeadlineDefaultTag>,
  typeof defaultProps
> = defaultProps;

export const ComparisonTableHeadline: (<
  Tag extends React.ElementType = ComparisonTableHeadlineDefaultTag
>(
  props: ComparisonTableHeadlineProps<Tag>
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableHeadlineProps, "tag"> = ({
  children,
  tag: CustomTag = ComparisonTableHeadlineDefaultTagName,
  ...restProps
}) => {
  return (
    <CustomTag className={styles.headline} {...restProps}>
      {children}
    </CustomTag>
  );
};

ComparisonTableHeadline.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  tag: PropTypes.elementType,
};

ComparisonTableHeadline.defaultProps = validatedDefaultProps;

export default ComparisonTableHeadline;
